import { render } from "./JsonToCSV.vue?vue&type=template&id=2f0b7d8e"
import script from "./JsonToCSV.vue?vue&type=script&lang=js"
export * from "./JsonToCSV.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__